// extracted by mini-css-extract-plugin
export var container = "_af-0";
export var icon = "_af-1";
export var text = "_af-2";